import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DivisionSalesRep } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class SalesRepService {
  constructor(private httpClient: HttpClient) {  }

  public getAllSalesReps(): Observable<DivisionSalesRep[]> {
    const url = `api/SalesRep/list/`;

    return this.httpClient.get<DivisionSalesRep[]>(url);
  }
}
